import React from 'react'
import PropTypes from 'prop-types'

// Components'
import { Text, Button, Popup } from '../../../..'

// assets
import { BotHead } from '../../../..'

// Hooks
import { useToggleGuestSignup } from '../../../../../hooks/routing'

// Constants
import { PATH_HELPERS } from '../../../../../constants/routes'

// styles
import styles from './Unauthorized.module.scss'

const Unauthorized = ({ onClose }) => {
  const toggleSignup = useToggleGuestSignup()

  return (
    <Popup onClose={onClose}>
      <div className={styles.svg}>
        <BotHead />
      </div>
      <Text color='white' weight='bold' size='l'>
        Do you have an account?
      </Text>
      <Text color='gray'>
        To continue, sign in with the email address you receive Homebot emails
        from.
      </Text>
      <Button
        onClick={() =>
          toggleSignup({
            redirectUrl: PATH_HELPERS.homebotForChromeSync.buildPath(),
          })
        }
        className={styles.btn}
        fullWidth
        secondary
      >
        Sign In
      </Button>
    </Popup>
  )
}

Unauthorized.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default Unauthorized
